// extracted by mini-css-extract-plugin
export default {"homescreen":"HomeScreen_homescreen__t8026"};